//---------------------------------------------------------------------------------------------------------------------- Imports
import { Row, Card, Typography, Col, Table, Tag, Spin } from "antd";
import { StyleSheet } from "../../../StyleSheet";
import {
    DownCircleFilled, FileDoneOutlined, HourglassOutlined, InfoCircleOutlined,
    LoadingOutlined,
    PrinterOutlined, RedoOutlined, RollbackOutlined, SwapOutlined, UpCircleFilled
} from "@ant-design/icons";
import { AccountResponse, AccountType, ComprobanteRequest, Period, State, Status, TransactionResume } from "../../../types/types";
import { ColumnsType } from "antd/es/table";
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import _ from "lodash";
import {
    getAccountById, getAccounts, getBanks, getPeriodsList, getTransactionsByAccountNumberAndPeriod, printReceiptment, printStatement
} from "../../../methods/axiosMethods";
import { useDispatch, useSelector } from "react-redux";
import { setInstitution } from "../../../store/slices/institutions";
import ModalEdoCuenta from "./ModalEdoCuenta";
import SubDefaultLayout from "../../../components/SubDefaultLayout";
import { subMenusOfAccounts } from "../../../commons/subMenus";
import SelectInput from "../../../components/SelectInput";
import Buttons from "../../../components/Buttons";
import CardButton from "../components/CardButton";
import GenericModal from "../../../components/GenericModal";
import ModalNotification, { AlertTypeNew } from "../../../components/ModalNotification";
import { PeriodInterface, formatAmount, labelChipColorAccountType, labelChipColorStatus, labelChipStatus, labelMonth, splicePeriodsLists } from "../../../functions/Functions";
import { setAccount } from "../../../store/slices/account";
import CustomPagination from "../../../components/CustomPagination";
import { setPeriod } from "../../../store/slices/periods";
const { Text } = Typography;

//---------------------------------------------------------------------------------------------------------------------- View
const MyAccountsDetails = () => {
    const params = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const accData = useSelector((state: any) => state.account.accountsInfo);
    const [accountNumber, setAccountNumber] = useState("");
    const [ifpe, setIfpe] = useState("");
    const [name, setName] = useState("");
    const [balance, setBalance] = useState(0);
    const banksList = useSelector((state: any) => state.institutions.institutionsInfo);
    const [periodsList, setPeriodsList] = useState<Array<Period>>([]);
    const [periods, setPeriods] = useState<PeriodInterface>({ periods: [] });
    // const [allPeriods, setAllPeriods] = useState<PeriodInterface>({ periods: [] });
    const [indexOfCurrentYear, setIndexOfCurrentYear] = useState<number>(0);
    const [indexOfCurrentMonth, setIndexOfCurrentMonth] = useState<number>(0);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState<TransactionResume>();
    const [openModalEdoCuenta, setOpenModalEdoCuenta] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingPrint, setIsLoadingPrint] = useState(false);
    const [accountType, setAccountType] = useState<AccountType>();
    const [transactionsList, setTransactionsList] = useState<Array<TransactionResume>>([]);
    const [notificationType, setNotificationType] = useState<AlertTypeNew>("SUCCESS");
    const [showNotification, setShowNotification] = useState<boolean>(false);
    const [accountData, setAccountData] = useState<AccountResponse>();
    const [message, setMessage] = useState('');
    const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;
    // const [monthSelected, setMonthSelected] = useState<string>("");
    const [totalPerPage, setTotalPerPage] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);

    const columns: ColumnsType<TransactionResume> = [
        {
            title: "Acciones",
            dataIndex: "operation",
            key: "operation",
            width: "25%",
            className: 'custom-header',
            render: (event, record: TransactionResume) => (
                <Row gutter={[16, 12]} >
                    <Col>
                        <Buttons
                            type={"default"}
                            title={"Más Detalles"}
                            action={() => showDrawer(record)}
                            color="#444cf9"
                            icon={<InfoCircleOutlined />} />
                    </Col>
                    {
                        record.status === State.DONE || record.status === State.PROCESSING || record.status === State.PENDING ? (
                            <Col >
                                <Buttons
                                    type={"default"}
                                    title={"Imprimir"}
                                    action={() => printReceipt(record)}
                                    color="#fcba50"
                                    icon={<PrinterOutlined />} />
                            </Col>
                        ) : null
                    }
                </Row>
            ),
        },
        {
            title: "Tipo",
            dataIndex: "transactionType",
            key: "transactionType",
            className: 'custom-header',
            render: (text, record) => {
                const statusInfo: any = {
                    DONE: {
                        textColor: record.incoming > 0 ? "#2ed2a7" : "#ea915f",
                        tagText: record.incoming > 0 ? "Ingreso" : "Egreso",
                        icon: record.incoming > 0 ? <DownCircleFilled style={{ color: "#2ed2a7" }} /> : <UpCircleFilled style={{ color: "#ea915f" }} />,
                    },
                    REJECTED: {
                        textColor: "#ff5780",
                        tagText: "Rechazada",
                        icon: <InfoCircleOutlined style={{ color: "red" }} />,
                    },
                    CANCELED: {
                        textColor: "#fd0061",
                        tagText: "Cancelada",
                        icon: <InfoCircleOutlined style={{ color: "#fd0061" }} />,
                    },
                    CREATED: {
                        textColor: "#ff5780",
                        tagText: "Rechazada",
                        icon: <InfoCircleOutlined style={{ color: "red" }} />,
                    },
                    PROCESSING: {
                        textColor: "blue",
                        tagText: "Procesando",
                        icon: <HourglassOutlined style={{ color: "#00abfb" }} />,
                    },
                    PENDING: {
                        textColor: "blue",
                        tagText: "Procesando",
                        icon: <HourglassOutlined style={{ color: "#00abfb" }} />,
                    },
                };

                const { tagText, icon, textColor } = statusInfo[record.status] || {};

                return (
                    <>
                        {icon && icon} &nbsp;&nbsp;
                        {textColor && (
                            <Text style={{ fontSize: 14, color: textColor }}>
                                {tagText}
                            </Text>
                        )}
                    </>
                );
            },
        },
        {
            title: "Fecha",
            dataIndex: "formatted",
            key: "formatted",
            className: 'custom-header',
        },
        {
            title: "Concepto de pago",
            dataIndex: "paymentConcept",
            key: "paymentConcept",
            className: 'custom-header',
        },
        {
            title: "Entidad Receptora",
            dataIndex: "receiverBank",
            key: "receiverBank",
            className: 'custom-header',
        },
        {
            title: "Cuenta Receptor",
            dataIndex: "receiverAccountNumber",
            key: "receiverAccountNumber",
            className: 'custom-header',
        },
        {
            title: "Monto",
            dataIndex: "incoming",
            key: "amount",
            className: 'custom-header',
            render: (text, record) => (
                <span style={{ color: record.incoming > 0 ? "#2ED2A7" : "#EA915F" }}>
                    {record.incoming > 0 ?
                        (record.incoming !== 0 ?
                            formatAmount.format(record.incoming + record.iva) : '$0.00')
                        : (record.outcoming !== 0 ?
                            formatAmount.format(record.outcoming + record.iva) : '$0.00')}
                </span>
            ),
        },
    ];

    useEffect(() => {
        setCurrentPage(1);
    }, [totalPerPage]);

    const fetchData = useCallback(
        (page?: number, pageChanged?: number) => {
            if (params !== undefined && params.accountNumber !== undefined) {
                const currentPageTmp = page ? page - 1 : 0;
                const currentPageChangedTmp = pageChanged ?? 10;

                if (periods && periods.periods[indexOfCurrentYear] && periods.periods[indexOfCurrentYear].months[indexOfCurrentMonth]) {
                    const periodComplete = `${periods.periods[indexOfCurrentYear].months[indexOfCurrentMonth]}-${periods.periods[indexOfCurrentYear].year}`;
                    setIsLoading(true);
                    getTransactionsByAccountNumberAndPeriod(params.accountNumber, periodComplete, currentPageTmp, currentPageChangedTmp)
                        .then((response) => {
                            const { data } = response;
                            if (data?.status === Status.OK && data?.data?.content) {
                                const transfersList = data.data.content;
                                setTransactionsList(transfersList);
                                setTotalRecords(data.data.totalElements);
                            } else {
                                setTransactionsList([]);
                                setTotalRecords(0);
                            }
                        })
                        .catch((error) => {
                            setTotalRecords(0);
                            setShowNotification(true);
                            setMessage("Hubo un error al obtener la lista de transacciones.")
                            setNotificationType('ERROR');
                            setShowNotification(true);
                        })
                        .finally(() => {
                            setIsLoading(false);
                        });
                }
            }
        },
        [indexOfCurrentMonth, indexOfCurrentYear, periods, params]
    );

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
        fetchData(page, totalPerPage);
    };

    const handleTotalPerPage = (total: number) => {
        setTotalPerPage(total);
        fetchData(1, total);
    };

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const getAllPeriodsFromAccount = useCallback(() => {
        if (params !== undefined && params.accountNumber !== undefined) {
            setIsLoading(true);
            getPeriodsList(params.accountNumber)
                .then((response) => {
                    if (response.data && response.data.data) {
                        if (response.data.status === Status.OK) {
                            dispatch(setPeriod({ periodsInfo: response.data.data.periods }))
                            setPeriodsList(response.data.data.periods);
                        }
                    }
                })
                .catch(() => {
                    setNotificationType('ERROR');
                    setMessage("Hubo un error al obtener la lista de Periodos");
                    setShowNotification(true);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }
    }, [params, dispatch]);

    const showDrawer = (record: TransactionResume) => {
        setOpenDrawer(true);
        setSelectedRecord(record);
    };

    useEffect(() => {
        getAllPeriodsFromAccount();
    }, [getAllPeriodsFromAccount]);

    useEffect(() => {
        if (!_.isEmpty(periodsList)) {
            setPeriods(splicePeriodsLists(periodsList));
        }
    }, [periodsList]);

    useEffect(() => {
        if (!_.isEmpty(periods)) {
            setIndexOfCurrentYear(0);
            setIndexOfCurrentMonth(0);
        }
    }, [periods]);


    const printReceipt = (transaction: TransactionResume) => {
        setIsLoadingPrint(true)
        let receiptReq: ComprobanteRequest = {
            trackingKey: transaction.trackingKey,
            accountNumberReceiver: transaction.receiverAccountNumber,
            accountNumberSource: transaction.sourceAccountNumber,
            transactionType: transaction.transactionType
        }
        printReceiptment(receiptReq)
            .then((response) => {
                setIsLoadingPrint(false);
            })
            .catch(() => {
                setIsLoadingPrint(false);
                setNotificationType('ERROR');
                setMessage("Hubo un error al imprimir el Comprobante de Pago, intente más tarde..");
                setShowNotification(true);
            })
    };

    const handleCloseModal = () => {
        setOpenModalEdoCuenta(false)
    };

    const getStatement = (period: string) => {
        setIsLoading(true);
        printStatement(accountNumber, period)
            .then((response) => {
                setIsLoading(false);
                setOpenModalEdoCuenta(false);
            })
            .catch(() => {
                setOpenModalEdoCuenta(false);
                setIsLoading(false);
                setNotificationType('ERROR');
                setMessage("Hubo un error al descargar el estado de cuenta, intente más tarde.");
                setShowNotification(true);
            })
    };

    const getAccountsList = useCallback(() => {
        setIsLoading(true);
        getAccounts()
            .then((response) => {
                if (response.data && response.data.data) {
                    if (response.data.status === Status.OK && !_.isEmpty(response.data.data)) {
                        dispatch(setAccount({
                            accountsInfo: response.data.data
                        }));
                    }
                }
                setIsLoading(false);
            })
            .catch(() => {
                setIsLoading(false);
                setNotificationType('ERROR');
                setMessage("Hubo un error al obtener la lista de cuentas, intente más tarde.");
                setShowNotification(true);
            })
    }, [dispatch]);

    useEffect(() => {
        getAccountsList();
    }, [getAccountsList]);

    useEffect(() => {
        if (banksList && _.isEmpty(banksList)) {
            getBanks()
                .then((response) => {
                    if (response.data.status === Status.OK && response.data.data && !_.isEmpty(response.data.data)) {
                        dispatch(setInstitution({ institutionsInfo: response.data.data }))
                    }
                })
                .catch(() => {
                    setNotificationType('ERROR');
                    setMessage("Hubo un error al obtener la lista Instituciones, intente más tarde...");
                    setShowNotification(true);
                });
        }
    }, [banksList, dispatch]);

    useEffect(() => {
        if (params !== undefined && params.accountNumber !== undefined
            && !_.isEmpty(accData)) {
            let group = _.find(accData, { accountNumber: params.accountNumber });
            setName(group.name);
            setAccountType(group.accountType);
            setAccountNumber(group.accountNumber);
            setIfpe(group.bank);
            setBalance(group.balance.balance)
        } else if (params !== undefined && params.accountNumber !== undefined && !_.isEmpty(banksList)) {
            setIsLoading(true);
            getAccountById(params.accountNumber)
                .then((response) => {
                    if (response.data.status === Status.OK) {
                        setName(response.data.data.name);
                        setAccountType(response.data.data.accountType);
                        setAccountNumber(response.data.data.accountNumber);
                        setBalance(response.data.data.balance.balance);
                        let bankData = _.find(banksList, { bankCode: response.data.data.bank });
                        setIfpe(bankData ? bankData.bankName : "");
                        setAccountData(response.data.data);
                    }
                    setIsLoading(false);
                })
                .catch(() => {
                    setIsLoading(false);
                    setNotificationType('ERROR');
                    setMessage("Hubo un error al obtener el detalle de la cuenta, intente más tarde...");
                    setShowNotification(true);
                });
        }
    }, [banksList, params, accData]);

    const handleOpenStatement = () => {
        if (periods && !_.isEmpty(periods.periods)) {
            setOpenModalEdoCuenta(true);
        } else {
            setShowNotification(true);
            setMessage("No hay periodos para consultar.");
            setNotificationType('INFO');
        }
    }

    const ListItem = ({ title, value }: any) => (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'left', margin: '10px' }}>
            <span style={{ fontWeight: 'bold' }}>
                {`${title}`}
            </span>
            <span style={{ lineHeight: '25px' }}>
                {value}
            </span>
        </div>
    );

    return (
        <SubDefaultLayout childrenSubMenu={subMenusOfAccounts} title="Detalles">
            <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={24} xxl={7}>
                    <Card style={styles.cardStyle}>
                        <Row>
                            <Col span={24}>
                                <Text style={styles.accountName}>
                                    {name}
                                </Text>
                            </Col>
                            <Col span={24}>
                                {`${ifpe} | ${accountType} ${accountNumber}`}
                            </Col>
                        </Row>
                    </Card>
                </Col>
                <Col xs={24} sm={24} md={12} xxl={5}>
                    <Card style={styles.cardStyle}>
                        <Row>
                            <Col span={24}>
                                Saldo Total
                            </Col>
                            <Col span={24}>
                                <Text style={styles.amountTotal}>
                                    {balance && balance !== 0 ? formatAmount.format(balance) : '$0.00'}
                                </Text>
                            </Col>
                            <Col span={24}>
                                MXN
                            </Col>
                        </Row>
                    </Card>
                </Col>
                <Col xs={24} sm={24} md={12} xxl={4}>
                    <CardButton
                        text={"Transferencia"}
                        color={"#f1eefc"}
                        icon={<SwapOutlined style={{ ...styles.iconStyles, color: "#765ce9" }} />}
                        action={() => navigate("/transfers/immediate", { state: accountData })}
                    />
                </Col>
                <Col xs={24} sm={24} md={12} xxl={4}>
                    <CardButton
                        text={"Estado de Cuenta"}
                        color={"#f1eefc"}
                        icon={<FileDoneOutlined style={{ ...styles.iconStyles, color: "#165bd0" }} />}
                        action={() => handleOpenStatement()}
                    />
                </Col>
                <Col xs={24} sm={24} md={12} xxl={4}>
                    <CardButton
                        text={"Regresar a Mis Cuentas"}
                        color={"#f1eefc"}
                        icon={<RollbackOutlined style={{ ...styles.iconStyles, color: "#ff3d6b" }} />}
                        action={() => navigate("/admin/accounts")}
                    />
                </Col>
                <Col span={24}>
                    <div style={styles.primaryContainer}>
                        <Row gutter={[16, 16]} align={"middle"}>
                            {(periods && periods.periods[indexOfCurrentYear]) && (
                                <>
                                    <Col xs={24} lg={8} xxl={9}>
                                        Detalle de Movimientos
                                    </Col>
                                    <Col xs={24} lg={6} xxl={6}>
                                        <SelectInput
                                            label={"Año"}
                                            value={periods.periods[indexOfCurrentYear].year}
                                            options={periods.periods.map((elem) => ({
                                                label: elem.year,
                                                value: elem.year
                                            }))}
                                            onChange={(value) => {
                                                setIndexOfCurrentMonth(0);
                                                setIndexOfCurrentYear(
                                                    periods.periods.findIndex(elem => elem.year === value)
                                                )
                                            }}
                                        />
                                    </Col>
                                    <Col xs={24} lg={6} xxl={6}>
                                        <SelectInput
                                            label={"Mes"}
                                            value={periods.periods[indexOfCurrentYear].months[indexOfCurrentMonth]}
                                            options={periods.periods[indexOfCurrentYear].months.map(elem => ({
                                                value: elem,
                                                label: labelMonth(elem).label
                                            }))}
                                            onChange={(value) => setIndexOfCurrentMonth(
                                                periods.periods[indexOfCurrentYear].months.findIndex(elem => elem === value)
                                            )}
                                        />

                                    </Col>
                                    <Col xs={24} lg={4} xxl={3} style={{ display: "flex", justifyContent: "center" }}>
                                        <Buttons
                                            type="primary"
                                            color="#3d84ff"
                                            action={() => fetchData(currentPage, totalPerPage)}
                                            icon={<RedoOutlined />}
                                            title="Actualizar"
                                        />
                                    </Col>
                                </>
                            )}
                        </Row>
                        <Row style={styles.tableContainer}>
                            <Col span={24}>
                                <Table
                                    bordered
                                    dataSource={transactionsList}
                                    columns={columns}
                                    scroll={{ y: 400, x: 700 }}
                                    locale={{ emptyText: "No hay datos disponibles" }}
                                    pagination={false}
                                    loading={{
                                        spinning: isLoading || isLoadingPrint,
                                        indicator: <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />,
                                    }}
                                />
                            </Col>
                            <Col xs={24}>
                                <CustomPagination
                                    currentPage={currentPage}
                                    pageSize={totalPerPage}
                                    paginationTotal={totalRecords}
                                    onPageSizeChange={handleTotalPerPage}
                                    onPageChange={handlePageChange}
                                    showSizeChanger
                                />
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
            <GenericModal
                show={openDrawer}
                title="Más detalles"
                showActionButtons={false}
                onClose={() => setOpenDrawer(false)}
            >
                {
                    isLoadingPrint ? (
                        <div style={styles.contentView}>
                            <Spin
                                indicator={antIcon}
                                tip="Cargando..."
                                style={styles.loading}
                            />
                        </div>
                    ) : (
                        <Row style={{ margin: "20px 0px 20px 0px" }}>
                            {selectedRecord &&
                                <Col span={18}>
                                    <ListItem title="Fecha y Hora" value={selectedRecord.date} />
                                    <ListItem title={selectedRecord.sourceBank === "STP" ? "IFPE Emisor: " : "Entidad Emisora: "} value={selectedRecord.sourceBank} />
                                    <ListItem title="Cuenta Emisor" value={selectedRecord.sourceAccountNumber} />
                                    <ListItem title="Nombre" value={selectedRecord.sourceName} />
                                    <ListItem title="R.F.C" value={selectedRecord.rfcOrCurp} />
                                    <ListItem title="Referencia" value={selectedRecord.reference} />
                                    <ListItem title="Clave de Rastreo" value={selectedRecord.trackingKey} />
                                    <ListItem title="Monto" value={formatAmount.format(selectedRecord.incoming !== 0 ? selectedRecord.incoming : selectedRecord.outcoming)} />
                                    <ListItem title="IVA" value={formatAmount.format(selectedRecord.iva)} />
                                    <ListItem title="Usuario" value={selectedRecord.username} />
                                    <div style={{ display: 'flex', flexDirection: 'row', flexFlow: 'wrap' }}>
                                        <Tag
                                            style={{ fontSize: 14 }}
                                            color={labelChipColorStatus(selectedRecord.status)}
                                        >
                                            {labelChipStatus(selectedRecord.status)}
                                        </Tag>
                                        <Tag
                                            style={{ fontSize: 14 }}
                                            color={labelChipColorAccountType(selectedRecord.accountType)}
                                        >
                                            {
                                                selectedRecord.accountType === "CLABE"
                                                    ? "CLABE"
                                                    : selectedRecord.accountType === "CEL"
                                                        ? "Teléfono celular"
                                                        : selectedRecord.accountType === "DEBIT"
                                                            ? "Tarjeta de Debito"
                                                            : ""
                                            }
                                        </Tag>
                                    </div>
                                    {selectedRecord.description !== '' ? (
                                        <ListItem title="Descripción" value={selectedRecord.description} />
                                    ) : null}
                                </Col>
                            }
                            {
                                selectedRecord?.status === State.DONE || selectedRecord?.status === State.PROCESSING || selectedRecord?.status === State.PENDING ?
                                    <Col span={6}>
                                        <Row justify={"center"}>
                                            <div style={styles.iconContainer}>
                                                <div
                                                    style={{ ...styles.iconButtonStyle, backgroundColor: "#ebf9fc" }}
                                                    onClick={() => selectedRecord && printReceipt(selectedRecord)}
                                                >
                                                    <PrinterOutlined style={styles.iconStyles} />
                                                </div>
                                                <Text>Imprimir</Text>
                                            </div>
                                        </Row>
                                    </Col>
                                    : null
                            }
                        </Row>
                    )
                }
            </GenericModal>
            <ModalEdoCuenta
                openModal={openModalEdoCuenta}
                handleClose={() => handleCloseModal()}
                periods={periods}
                printStatement={getStatement}
                isLoading={isLoading}
            />
            <ModalNotification
                title={"Detalle"}
                message={message}
                alertType={notificationType}
                show={showNotification}
                onClose={() => setShowNotification(false)}
            />
        </SubDefaultLayout >
    );
}

//---------------------------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    cardStyle: {
        boxShadow: "0px 0px 8px #00000029",
        borderRadius: 15,
        border: "none",
        height: "100%",
        display: "flex",
        alignItems: "center",
    },
    primaryContainer: {
        padding: "20px",
        borderRadius: 10,
        backgroundColor: 'white',
        boxShadow: "rgba(177, 179, 185, 0.51) 5px 8px 24px 5px",
    },
    tableContainer: {
        marginTop: "40px"
    },
    iconStyles: {
        fontSize: 25,
    },
    iconContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: 20,
    },
    iconButtonStyle: {
        display: "flex",
        width: 70,
        height: 70,
        marginBottom: 10,
        borderRadius: "50%",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#ff00ff",
        cursor: "pointer",
    },
    accountName: {
        fontSize: 18,
        fontWeight: 600,
        color: '#4242ff'
    },
    amountTotal: {
        fontSize: 28,
        fontWeight: 600,
        color: '#4242ff'
    },
    contentView: {
        width: "100%",
        height: "50vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    loading: {
        maxHeight: "none",
    },
});

//---------------------------------------------------------------------------------------------------------------------- Exports
export default MyAccountsDetails;
